<template>
    <div class="c-input-notes">

        <b-alert v-if="count('') === 0" show variant="light">{{Core.Definition.getDefinition('Aucune note à afficher')}}</b-alert>

        <b-list-group v-if="count('') > 0" class="list-group-accent">

            <b-list-group-item v-if="count('critical') > 0" class="list-group-item-accent-danger bg-danger text-center font-weight-bold text-uppercase small">
                {{Core.Definition.getDefinition('Critique')}}
            </b-list-group-item>

            <b-list-group-item :key="noteIndex" v-for="note, noteIndex in dataValue" v-if="note.level === 'critical'" href="#" class="list-group-item-accent-danger">
                <div class="float-right">
                    <button type="button" @click="edit(noteIndex)" class="btn btn-edit btn-sm mr-2"><i class="fa fa-edit"></i></button>
                    <button type="button" @click="trash(noteIndex)" class="btn btn-danger btn-sm"><i class="fa fa-trash-o"></i></button>
                </div>
                <div class="pb-2">
                    {{note.message}}
                </div>
                <small class="text-muted mr-3">
                    <i class="fa fa-calendar"></i>&nbsp;{{ Core.Definition.getDefinition('Créé le') }} {{Core.Date.format(note.creationDate, 'DD MMM YYYY')}}
                </small>
            </b-list-group-item>

            <hr class="transparent mx-3 my-0">
            <b-list-group-item v-if="count('moderate') > 0" class="list-group-item-accent-warning bg-warning text-center font-weight-bold text-uppercase small">
                Importance modéré
            </b-list-group-item>

            <b-list-group-item :key="noteIndex" v-for="note, noteIndex in dataValue" v-if="note.level === 'moderate'" href="#" class="list-group-item-accent-warning">
                <div class="float-right">
                    <button type="button" @click="edit(noteIndex)" class="btn btn-edit btn-sm mr-2"><i class="fa fa-edit"></i></button>
                    <button type="button" @click="trash(noteIndex)" class="btn btn-danger btn-sm"><i class="fa fa-trash-o"></i></button>
                </div>
                <div class="pb-2">
                    {{note.message}}
                </div>
                <small class="text-muted mr-3">
                    <i class="fa fa-calendar"></i>&nbsp;{{ Core.Definition.getDefinition('Créé le') }} {{Core.Date.format(note.creationDate, 'DD MMM YYYY')}}
                </small>
            </b-list-group-item>

            <hr class="transparent mx-3 my-0">
            <b-list-group-item v-if="count('normal') > 0" class="list-group-item-accent-info bg-info text-center font-weight-bold text-uppercase small">
                {{Core.Definition.getDefinition('À savoir')}}
            </b-list-group-item>

            <b-list-group-item  :key="noteIndex" v-for="note, noteIndex in dataValue" v-if="note.level !== 'critical' && note.level !== 'moderate'" href="#" class="list-group-item-accent-light">
                <div class="float-right">
                    <button type="button" @click="edit(noteIndex)" class="btn btn-edit btn-sm mr-2"><i class="fa fa-edit"></i></button>
                    <button type="button" @click="trash(noteIndex)" class="btn btn-danger btn-sm"><i class="fa fa-trash-o"></i></button>
                </div>
                <div class="pb-2">
                    {{note.message}}
                </div>
                <small class="text-muted mr-3">
                    <i class="fa fa-calendar"></i>&nbsp;{{ Core.Definition.getDefinition('Créé le') }} {{Core.Date.format(note.creationDate, 'DD MMM YYYY')}}
                </small>
            </b-list-group-item>

        </b-list-group>

        <hr/>
        <div>
            <b-row>
                <b-col lg="12" sm="12">
                    <b-form-textarea :ref="id + '_message'" :placeholder="Core.Definition.getDefinition('Écrire une note...')" :rows=3
                                     v-model="dataNote.message"></b-form-textarea>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col lg="7" md="6" sm="12">
                    <InputSelect
                            :ref="id + '_level'"
                            :id="id + '_level'"
                            :options="dataOptions"
                            :label="Core.Definition.getDefinition('Niveau d\'importance')"
                            v-model="dataNote.level"></InputSelect>
                </b-col>
                <b-col lg="5" md="6" sm="12">
                    <button type="button" @click="add" class="btn btn-edit mt-4"><i class="fa fa-plus mr-2"></i>{{Core.Definition.getDefinition('Ajouter')}}</button>
                </b-col>
            </b-row>
        </div>

        <b-modal :title="Core.Definition.getDefinition('Modification de la note')" class="modal-info" v-model="dataEditModal.show" @ok="saveEdit" :ok-title="Core.Definition.getDefinition('Ok')" ok-variant="edit" :cancel-title="Core.Definition.getDefinition('Annuler')" cancel-variant="light">
            <b-row>
                <b-col lg="12" sm="12">
                    <b-form-textarea :ref="id + '_editMessage'" :placeholder="Core.Definition.getDefinition('Écrire une note...')" :rows=3
                                     v-model="dataEditModal.note.message"></b-form-textarea>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col lg="7" md="6" sm="12">
                    <InputSelect
                            :ref="id + '_editLevel'"
                            :id="id + '_editLevel'"
                            :options="dataOptions"
                            :label="Core.Definition.getDefinition('Niveau d\'importance')"
                            v-model="dataEditModal.note.level"></InputSelect>
                </b-col>
            </b-row>
        </b-modal>

        <b-modal :title="Core.Definition.getDefinition('Suppression de la note')" class="modal-danger" v-model="dataDeleteModal.show" @ok="confirmTrash" :ok-title="Core.Definition.getDefinition('Supprimer')" ok-variant="danger" :cancel-title="Core.Definition.getDefinition('Annuler')" cancel-variant="light">
            <p>
                {{Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer cette note?')}}
            </p>
        </b-modal>
    </div>
</template>

<script>

  import InputSelect from "./InputSelect"
  export default {
      name: 'InputNotes',
      components: {
          InputSelect
      },
      props: {
          value: {
              type: Array,
              default: function() {
                  return []
              }
          },
          id: {
              type: String,
              default: ''
          },
          form: {
              type: Object,
              default: function() {return {}}
          },
          fieldRefs: {
              type: Array,
              default: function() { return [] }
          },
          options: {
              type: Array,
              default: function () {
                  return [
                      {
                          label: Core.Definition.getDefinition('Normal'),
                          value: 'normal'
                      },
                      {
                          label: Core.Definition.getDefinition('Critique'),
                          value: 'critical'
                      }
                  ]
              }
          }
      },
      watch: {
          value(val) {
              this.dataValue = val
          },
          dataValue(val) {
              this.$emit('input', val)
          }
      },
      mounted() {

          this.dataOptions = this.options

          this.dataValue = this.value
          this.reset()
      },
      data: () => {
          return {
              Core: window.Core,
              dataValue: [],
              dataEditModal: {
                  show: false,
                  note: {
                      message: '',
                      level: null,
                      creationDate: '',
                      index: ''
                  }
              },
              dataDeleteModal: {
                  show: false,
                  note: {
                      index: ''
                  }
              },
              dataNote: {
                  message: '',
                  level: null,
                  creationDate: ''
              },
              dataOptions: [
                  {
                      label: Core.Definition.getDefinition('Normal'),
                      value: 'normal'
                  },
                  {
                      label: Core.Definition.getDefinition('Critique'),
                      value: 'critical'
                  }
              ]
          }
      },
      methods: {
          count(level) {
              let count = 0
              for(let note in this.dataValue) {
                  note = this.dataValue[note]
                  if (note.level === level || level === '') {
                      count ++
                  }
              }
              return count
          },
          add() {
              let message = this.dataNote.message
              let level = Core.Value.decode(this.dataNote.level, 'select')
              let creationDate = Core.Date.getToday('YYYY-MM-DD')
              if (message !== '') {
                  this.dataValue.push(
                      {
                          message: message,
                          level: level,
                          creationDate: creationDate
                      }
                  )
              }
              this.reset()
          },
          edit(noteIndex) {
              this.dataEditModal.note.message = this.dataValue[noteIndex].message
              this.dataEditModal.note.level = Core.Value.selectValue(this.dataValue[noteIndex].level, this.dataOptions)
              this.dataEditModal.note.creationDate = this.dataValue[noteIndex].creationDate
              this.dataEditModal.note.index = noteIndex
              this.dataEditModal.show = true
          },
          saveEdit() {
              this.dataValue[this.dataEditModal.note.index].message = this.dataEditModal.note.message
              this.dataValue[this.dataEditModal.note.index].level = Core.Value.decode(this.dataEditModal.note.level, 'select')
              this.dataValue[this.dataEditModal.note.index].creationDate = this.dataEditModal.note.creationDate
              this.dataEditModal.show = false
              this.reset()
          },
          trash(noteIndex) {
              this.dataDeleteModal.note.index = noteIndex
              this.dataDeleteModal.show = true
          },
          confirmTrash() {
              this.dataValue.splice(this.dataDeleteModal.note.index, 1)
              this.dataEditModal.show = false
              this.reset()
          },
          reset() {
              this.dataDeleteModal.note.index = ''

              this.dataEditModal.note.message = ''
              this.dataEditModal.note.level = Core.Value.selectValue('normal', this.dataOptions)
              this.dataEditModal.note.creationDate = ''
              this.dataEditModal.note.index = ''

              this.dataNote.message = ''
              this.dataNote.level = Core.Value.selectValue('normal', this.dataOptions)
              this.dataNote.creationDate = ''
          }
      }
  }
</script>